/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Submission

Properties:
  approved: boolean
  createdAt: string
  description: string
  externalDataSource: string
  excludedAiTags: array
  foundry: object
  id: string
  isEditable: boolean
  liveEdit: boolean
  isLive: boolean
  isUniqueName: boolean
  mergeWithExistingFamily: boolean
  messageHistory: array
  myFontsLastModified: string
  owner: object
  pimLastModified: string
  progress: object
  revisionId: string
  status: string
  updatedAt: string
  useExistingStyles: boolean
  userId: string
  userMetaData: object
  validationResult: object
  vendor: object
*/

var Submission = (function () {
  function validateSubmission (arg) {
    // Validate description
    if (arg.description && !(typeof arg.description === 'string')) {
      throw new Error('Submission.description: Wrong type: Got \'' + (typeof arg.description) + '\', but expected: \'string\'')
    }
    // Validate externalDataSource
    if (arg.externalDataSource && !(typeof arg.externalDataSource === 'string')) {
      throw new Error('Submission.externalDataSource: Wrong type: Got \'' + (typeof arg.externalDataSource) + '\', but expected: \'string\'')
    }
    // Validate excludedAiTags
    if (arg.excludedAiTags && !(Array.isArray(arg.excludedAiTags))) {
      throw new Error('Submission.excludedAiTags: Wrong type: Got \'' + (typeof arg.excludedAiTags) + '\', but expected: \'array\'')
    }
    // Validate foundry
    if (arg.foundry && !(typeof arg.foundry === 'object')) {
      throw new Error('Submission.foundry: Wrong type: Got \'' + (typeof arg.foundry) + '\', but expected: \'object\'')
    }
    // Validate liveEdit
    if (arg.liveEdit && !(typeof arg.liveEdit === 'boolean')) {
      throw new Error('Submission.liveEdit: Wrong type: Got \'' + (typeof arg.liveEdit) + '\', but expected: \'boolean\'')
    }
    // Validate isLive
    if (arg.isLive && !(typeof arg.isLive === 'boolean')) {
      throw new Error('Submission.isLive: Wrong type: Got \'' + (typeof arg.isLive) + '\', but expected: \'boolean\'')
    }
    // Validate isUniqueName
    if (arg.isUniqueName && !(typeof arg.isUniqueName === 'boolean')) {
      throw new Error('Submission.isUniqueName: Wrong type: Got \'' + (typeof arg.isUniqueName) + '\', but expected: \'boolean\'')
    }
    // Validate mergeWithExistingFamily
    if (arg.mergeWithExistingFamily && !(typeof arg.mergeWithExistingFamily === 'boolean')) {
      throw new Error('Submission.mergeWithExistingFamily: Wrong type: Got \'' + (typeof arg.mergeWithExistingFamily) + '\', but expected: \'boolean\'')
    }
    // Validate messageHistory
    if (arg.messageHistory && !(Array.isArray(arg.messageHistory))) {
      throw new Error('Submission.messageHistory: Wrong type: Got \'' + (typeof arg.messageHistory) + '\', but expected: \'array\'')
    }
    // Validate myFontsLastModified
    if (arg.myFontsLastModified && !(typeof arg.myFontsLastModified === 'string')) {
      throw new Error('Submission.myFontsLastModified: Wrong type: Got \'' + (typeof arg.myFontsLastModified) + '\', but expected: \'string\'')
    }
    // Validate owner
    if (arg.owner && !(typeof arg.owner === 'object')) {
      throw new Error('Submission.owner: Wrong type: Got \'' + (typeof arg.owner) + '\', but expected: \'object\'')
    }
    // Validate pimLastModified
    if (arg.pimLastModified && !(typeof arg.pimLastModified === 'string')) {
      throw new Error('Submission.pimLastModified: Wrong type: Got \'' + (typeof arg.pimLastModified) + '\', but expected: \'string\'')
    }
    // Validate status
    if (arg.status && !(typeof arg.status === 'string')) {
      throw new Error('Submission.status: Wrong type: Got \'' + (typeof arg.status) + '\', but expected: \'string\'')
    }
    // Validate useExistingStyles
    if (arg.useExistingStyles && !(typeof arg.useExistingStyles === 'boolean')) {
      throw new Error('Submission.useExistingStyles: Wrong type: Got \'' + (typeof arg.useExistingStyles) + '\', but expected: \'boolean\'')
    }
    // Validate userMetaData
    if (arg.userMetaData && !(typeof arg.userMetaData === 'object')) {
      throw new Error('Submission.userMetaData: Wrong type: Got \'' + (typeof arg.userMetaData) + '\', but expected: \'object\'')
    }
    // Validate vendor
    if (arg.vendor && !(typeof arg.vendor === 'object')) {
      throw new Error('Submission.vendor: Wrong type: Got \'' + (typeof arg.vendor) + '\', but expected: \'object\'')
    }
  }
  function buildSubmission (arg) {
    var Submission = arg
    // Complete description
    // Expected Type: string
    Submission.description = Submission.description || ''
    // Complete externalDataSource
    // Expected Type: string
    Submission.externalDataSource = Submission.externalDataSource || ''
    // Complete excludedAiTags
    // Expected Type: array
    Submission.excludedAiTags = Submission.excludedAiTags || []
    // Complete foundry
    // Expected Type: object
    Submission.foundry = Submission.foundry || {}
    // Complete foundry.credibility
    // Expected Type: string
    Submission.foundry.credibility = Submission.foundry.credibility || ''
    // Complete foundry.foundryId
    // Expected Type: string
    Submission.foundry.foundryId = Submission.foundry.foundryId || ''
    // Complete foundry.name
    // Expected Type: string
    Submission.foundry.name = Submission.foundry.name || ''
    // Complete liveEdit
    // Expected Type: boolean
    Submission.liveEdit = Submission.liveEdit || false
    // Complete isLive
    // Expected Type: boolean
    Submission.isLive = Submission.isLive || false
    // Complete isUniqueName
    // Expected Type: boolean
    Submission.isUniqueName = Submission.isUniqueName || false
    // Complete mergeWithExistingFamily
    // Expected Type: boolean
    Submission.mergeWithExistingFamily = Submission.mergeWithExistingFamily || false
    // Complete messageHistory
    // Expected Type: array
    Submission.messageHistory = Submission.messageHistory || []
    // Complete myFontsLastModified
    // Expected Type: string
    Submission.myFontsLastModified = Submission.myFontsLastModified || ''
    // Complete owner
    // Expected Type: object
    Submission.owner = Submission.owner || {}
    // Complete owner.displayName
    // Expected Type: string
    Submission.owner.displayName = Submission.owner.displayName || ''
    // Complete owner.email
    // Expected Type: string
    Submission.owner.email = Submission.owner.email || ''
    // Complete owner.userId
    // Expected Type: string
    Submission.owner.userId = Submission.owner.userId || ''
    // Complete pimLastModified
    // Expected Type: string
    Submission.pimLastModified = Submission.pimLastModified || ''
    // Complete status
    // Expected Type: string
    Submission.status = Submission.status || ''
    // Complete useExistingStyles
    // Expected Type: boolean
    Submission.useExistingStyles = Submission.useExistingStyles || false
    // Complete userMetaData
    // Expected Type: object
    Submission.userMetaData = Submission.userMetaData || {}
    // Complete userMetaData.binaries
    // Expected Type: array
    Submission.userMetaData.binaries = Submission.userMetaData.binaries || []
    // Complete userMetaData.category
    // Expected Type: object
    Submission.userMetaData.category = Submission.userMetaData.category || {}
    // Complete userMetaData.customerMessage
    // Expected Type: string
    Submission.userMetaData.customerMessage = Submission.userMetaData.customerMessage || ''
    // Complete userMetaData.defaultLayoutFont
    // Expected Type: object
    Submission.userMetaData.defaultLayoutFont = Submission.userMetaData.defaultLayoutFont || {}
    // Complete userMetaData.designers
    // Expected Type: array
    Submission.userMetaData.designers = Submission.userMetaData.designers || []
    // Complete userMetaData.externalSku
    // Expected Type: string
    Submission.userMetaData.externalSku = Submission.userMetaData.externalSku || ''
    // Complete userMetaData.family
    // Expected Type: object
    Submission.userMetaData.family = Submission.userMetaData.family || {}
    // Complete userMetaData.familyDescriptions
    // Expected Type: array
    Submission.userMetaData.familyDescriptions = Submission.userMetaData.familyDescriptions || []
    // Complete userMetaData.familyGroup
    // Expected Type: object
    Submission.userMetaData.familyGroup = Submission.userMetaData.familyGroup || {}
    // Complete userMetaData.familyPriceUsd
    // Expected Type: number
    Submission.userMetaData.familyPriceUsd = Submission.userMetaData.familyPriceUsd || 0
    // Complete userMetaData.formats
    // Expected Type: array
    Submission.userMetaData.formats = Submission.userMetaData.formats || []
    // Complete userMetaData.imageSortorders
    // Expected Type: array
    Submission.userMetaData.imageSortorders = Submission.userMetaData.imageSortorders || []
    // Complete userMetaData.myFontsbinaries
    // Expected Type: array
    Submission.userMetaData.myFontsbinaries = Submission.userMetaData.myFontsbinaries || []
    // Complete userMetaData.ownDesign
    // Expected Type: boolean
    Submission.userMetaData.ownDesign = Submission.userMetaData.ownDesign || false
    // Complete userMetaData.packages
    // Expected Type: array
    Submission.userMetaData.packages = Submission.userMetaData.packages || []
    // Complete userMetaData.pimBinaries
    // Expected Type: array
    Submission.userMetaData.pimBinaries = Submission.userMetaData.pimBinaries || []
    // Complete userMetaData.releaseInfo
    // Expected Type: object
    Submission.userMetaData.releaseInfo = Submission.userMetaData.releaseInfo || {}
    // Complete userMetaData.tags
    // Expected Type: array
    Submission.userMetaData.tags = Submission.userMetaData.tags || []
    // Complete userMetaData.familyNotes
    // Expected Type: array
    Submission.userMetaData.familyNotes = Submission.userMetaData.familyNotes || []
    // Complete vendor
    // Expected Type: object
    Submission.vendor = Submission.vendor || {}
    // Complete vendor.name
    // Expected Type: string
    Submission.vendor.name = Submission.vendor.name || ''
    // Complete vendor.vendorId
    // Expected Type: string
    Submission.vendor.vendorId = Submission.vendor.vendorId || ''
    return Submission
  }
  return {
    validate: validateSubmission,
    build: buildSubmission
  }
})()

module.exports = Submission
